import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import FAQ from './pages/FAQ';
import Login from './pages/Login';
import Register from './pages/Register';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import Dashboard from './pages/Dashboard';
import Upload from './pages/Upload';
import Quiz from './pages/Quiz';
import Profile from './pages/Profile';
import QuizLanding from './pages/QuizLanding';
import SectionMetrics from './pages/SectionMetrics';
import ReviewAnswers from './pages/ReviewAnswers';
import { AuthProvider } from './services/AuthContext';
import ForgotUsername from './pages/ForgotUsername';

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <Navbar />
          <main className="main-content">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/faq" element={<FAQ />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/forgot-username" element={<ForgotUsername />} />
              <Route path="/reset-password" element={<ResetPassword />} /> 
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/upload" element={<Upload />} />
              <Route path="/quiz/:id" element={<QuizLanding />} />
              <Route path="/quiz/:id/metrics" element={<SectionMetrics />} />
              <Route path="/quiz/:id/take" element={<Quiz />} />
              <Route path="/profile" element={<Profile />} />
              <Route path="/review/:attemptId" element={<ReviewAnswers />} />
            </Routes>
          </main>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;